<script>
	import Footer from '$lib/components/layout/footer.svelte';
	import Header from '$lib/components/layout/header.svelte';
	import ProgressBar from '$lib/components/layout/progress-bar.svelte';
	import PageTransition from '$lib/components/transition.svelte';
	import { Toaster } from '$lib/components/ui/sonner';
	import { ModeWatcher } from 'mode-watcher';
	import '../app.css';
	import { page } from '$app/stores';

	export let data;
</script>

<svelte:head>
	<link rel="canonical" href="https://{$page.url.hostname}{$page.url.pathname}" />
</svelte:head>

<Toaster />
<ProgressBar class="text-green-500" />
<ModeWatcher track={false} defaultMode="light" />

<div class="wrapper">
	<Header />

	<main>
		<PageTransition url={data.url}>
			<slot />
		</PageTransition>
	</main>

	<Footer />
</div>

<style>
	.wrapper {
		display: grid;
		min-height: 100vh;
		grid-template-rows: auto 1fr auto;
	}
</style>
